import { ArrowRight } from "lucide-react";
import { ArticleCard } from "../../components/activities/ArticleCard";
import type { ArticleGridComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { resolveLinkHref } from "../../utils/links";

/** Article grid renderer. The optional call-to-action ("Voir tout") renders
 *  BELOW the grid as the site-wide "see all" convention — a left-aligned blue
 *  text link with a yellow arrow (matching LatestArticleGrid's "Tous les
 *  articles"), not a filled pill, so every listing reads as one design system. */
export function ArticleGridRenderer({ component }: { component: ArticleGridComponent }) {
  const { items, ctaHref, ctaLabel } = component.content;
  const resolvedCtaHref = resolveLinkHref(ctaHref);
  return (
    <section>
      <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
        {items.map((a, i) => (
          <ArticleCard key={`${a.title}-${i}`} {...a} />
        ))}
      </div>
      {resolvedCtaHref && ctaLabel ? (
        <div className="mt-4">
          <RuntimeLink
            href={resolvedCtaHref}
            className="inline-flex items-center gap-2 text-[18px] xl:text-[20px] text-[#0069B4] hover:text-[#005CA9]"
            aria-label={ctaLabel}
          >
            {ctaLabel}
            <ArrowRight className="h-4 w-4 shrink-0 text-[#FFA401]" />
          </RuntimeLink>
        </div>
      ) : null}
    </section>
  );
}


